import { type Company } from "@/schema"
import { useMutation, useQueryClient } from "@tanstack/react-query"

import { useApiContext } from "@/hooks/api/use-api-context"

import { regenerateCompanyVoiceProfile, updateCompany } from "./api"

export function useUpdateCompany() {
  const getContext = useApiContext()
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (
      data: Partial<Company> & {
        logoFile?: File
        remove_logo?: boolean
        darkModeLogoFile?: File
        remove_dark_mode_logo?: boolean
        regenerate_branding?: boolean
      }
    ) => {
      const context = await getContext()
      if (!context) throw new Error("No context found")

      return updateCompany(context, data)
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["company"] })
      queryClient.invalidateQueries({ queryKey: ["user", "me"] })
      // Company logos render inside the brand profile document
      queryClient.invalidateQueries({ queryKey: ["brandKitPreview"] })
    },
  })
}

export function useRegenerateCompanyVoiceProfile() {
  const getContext = useApiContext()
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async () => {
      const context = await getContext()
      if (!context) throw new Error("No context found")

      return regenerateCompanyVoiceProfile(context)
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["company"] })
    },
  })
}
